/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_login_oidc_failed_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong while connecting to the game. Please try signing in again.`)
};

const zh_hans1_login_oidc_failed_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连接游戏时出现问题，请重新尝试登录。`)
};

const zh_hant1_login_oidc_failed_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連線遊戲時發生問題，請重新嘗試登入。`)
};

const fr_login_oidc_failed_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un problème est survenu lors de la connexion au jeu. Veuillez réessayer de vous connecter.`)
};

const de_login_oidc_failed_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Verbinden mit dem Spiel ist ein Problem aufgetreten. Bitte versuche die Anmeldung erneut.`)
};

const ja_login_oidc_failed_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームへの接続中に問題が発生しました。もう一度サインインしてください。`)
};

const ko_login_oidc_failed_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게임 연결 중 문제가 발생했습니다. 다시 로그인해 주세요.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_oidc_failed_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_oidc_failed_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_oidc_failed_desc", locale)
	if (locale === "en") return en_login_oidc_failed_desc(inputs)
	if (locale === "zh-Hans") return zh_hans1_login_oidc_failed_desc(inputs)
	if (locale === "zh-Hant") return zh_hant1_login_oidc_failed_desc(inputs)
	if (locale === "fr") return fr_login_oidc_failed_desc(inputs)
	if (locale === "de") return de_login_oidc_failed_desc(inputs)
	if (locale === "ja") return ja_login_oidc_failed_desc(inputs)
	return ko_login_oidc_failed_desc(inputs)
};